// Ustore brand logo — uses uploaded PNG asset.
// LogoMark = oval emblem only (palu + cart inside circle), good for favicon/small spots.
// LogoFull = emblem + "USTORE / MARKETPLACE + LELANG" text below.

export function LogoMark({ size = 32, className = "" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="Ustore"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function LogoFull({ height = 40, className = "" }) {
  // image aspect ≈ 515:585 (slightly taller than wide)
  return (
    <img
      src="/logo-full.png"
      alt="Ustore — Marketplace + Lelang"
      className={`object-contain ${className}`}
      style={{ height, width: "auto" }}
    />
  );
}

export default LogoMark;
